import FilterTextInput from './FilterTextInput';
import FilterSelectInput from './FilterSelectInput';

export const FILTER_INPUT_COMPONENTS = {
  text: FilterTextInput,
  select: FilterSelectInput
};